<template>
  <div>
    <div class="uk-flex uk-flex-column" >

      <google-map name="example"></google-map>

    </div>

  </div>
</template>



<script>
//import { AUTH_LOGOUT } from "@/store/actions/auth.js";
import SyncLoader from 'vue-spinner/src/SyncLoader.vue'
import axios from "axios";
import { settings } from "@/settings";

let API_SERVER = settings.API_SERVER;

export default {
  name: "Home",
  data: function () {
    return {
    sidebar_widgets: [],
    footer_left_widgets: [],
    footer_right_widgets: [],
  }},
  methods: {
    logout: function() {
      this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push("/login"));
    },
  },
  mounted: function () {
    //console.log("mounted");
  },
};
</script>
